import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthFrame } from "@/layout/AuthFrame";
import { Btn, Field, Overline } from "@/components/kit";
import { api, apiError, setAccessToken } from "@/lib/api";
import { toast } from "@/components/ui/sonner";

export default function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !code || !password) return toast.error("Please fill in all fields.");
    if (password.length < 10) return toast.error("Password must be at least 10 characters.");
    setLoading(true);
    try {
      await api.post("/api/auth/reset-password", { email: email.trim(), code: code.trim(), new_password: password });
      setAccessToken(null);
      toast.success("Password updated. Redirecting to sign in…");
      setTimeout(() => navigate("/login"), 1200);
    } catch (err) {
      toast.error(apiError(err, "Unable to reset password."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthFrame>
      <Overline className="text-center mb-3">Enter your code</Overline>
      <h1 className="font-serif text-4xl text-ink text-center">New password</h1>
      <p className="text-inkfaint text-center mt-2 mb-8">
        Enter the 6-digit code from your email and choose a new password (at least 10 characters).
      </p>
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <Field label="Email" type="email" placeholder="you@example.com" value={email}
          onChange={(e) => setEmail(e.target.value)} data-testid="reset-email" autoComplete="email" />
        <Field label="Reset code" placeholder="6-digit code" value={code}
          onChange={(e) => setCode(e.target.value)} data-testid="reset-code" inputMode="numeric" />
        <Field label="New password" type="password" placeholder="At least 10 characters" value={password}
          onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" autoComplete="new-password" />
        <Btn type="submit" className="w-full" disabled={loading} data-testid="reset-submit">
          {loading ? "Resetting…" : "Reset password"}
        </Btn>
      </form>
      <p className="text-center text-sm mt-8">
        <Link to="/login" className="text-gold hover:underline">Back to sign in</Link>
      </p>
    </AuthFrame>
  );
}
